module.exports = __webpack_public_path__ + "static/paneheader-18ba1ab7cc0181df2d89aa04d9e94c93.png";